import { useMediaQuery, useTheme } from '@mui/material';

type UseScreenSizeOptions = {
  breakpoint?: number;
};

export const useScreenSize = ({ breakpoint = 860 }: UseScreenSizeOptions = {}) => {
  const theme = useTheme();
  const isWideScreen = useMediaQuery(theme.breakpoints.up(breakpoint));
  const isSmallScreen = useMediaQuery(theme.breakpoints.down(breakpoint));

  return { isWideScreen, isSmallScreen };
};
